import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-filtros-pedidos',
  templateUrl: './filtros-pedidos.component.html',
  styleUrls: ['./filtros-pedidos.component.scss']
})
export class FiltrosPedidosComponent {
  @Input() datas: any[] = [];
  @Input() status: any[] = [];
  @Input() localizacoes: any[] = [];
  @Input() filtros: any[] = [];
  
  @Output() filtroAplicado: EventEmitter<any> = new EventEmitter();

  dataSelecionada: any;
  date: Date | null = null; 
  dateEnd: Date | null = null; 
  statusSelecionado: any;
  localizacaoSelecionada: any;
  filtroSelecionada: any;
  valorFiltro: string = '';

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.date = new Date(moment().subtract(30, 'days').format());
    this.dateEnd = new Date(moment().format());

    this.datas = [
      { id: 0, nome: 'Selecione', api: '' },
      { id: 1, nome: 'Data', api: 'data' },
      { id: 2, nome: 'Previsão', api: 'previsao' },
      { id: 3, nome: 'Entrega', api: 'entrega' },
      { id: 4, nome: 'Faturamento', api: 'faturamento' },
    ];

    this.dataSelecionada = this.datas[1];

    this.filtros = [
      { id: 1, nome: 'Paciente', api: 'paciente' },
      { id: 2, nome: 'Solicitante', api: 'solicitante' },
      { id: 3, nome: 'Loja', api: 'loja' },
      { id: 4, nome: 'OS', api: 'os_loja' },
      { id: 5, nome: 'Laboratório', api: 'laboratorio' },
      { id: 6, nome: 'Pedido Lab', api: 'pedido_lab' }
    ];

    this.status = [
      { id: 1, nome: 'Todos' },
      { id: 2, nome: 'Aprovação' },
      { id: 3, nome: 'Produção' },
      { id: 4, nome: 'Entregues' },
      { id: 5, nome: 'Cancelados' },
      { id: 6, nome: 'Atrasados' },
      { id: 7, nome: 'Aprovados' },
    ]

    this.statusSelecionado = this.status[0];

    // Verifica os parâmetros da url para iniciar a tela já filtrando
    this.route.queryParams.subscribe(params => {
      
      if (params['status']) {
        const itemStatus = this.status.find(item => item.nome === params['status']);

        if (itemStatus) {
          this.statusSelecionado = itemStatus;
        }
      }

      if(['Aprovação', 'Produção', 'Atrasados', 'Aprovados', 'Cancelados'].includes(params['status']) && !params['valor_filtro_data_inicial'] && !params['valor_filtro_data_final']) {
        this.date = null;
        this.dateEnd = null
        this.dataSelecionada = this.datas[0];
      } else {
        if(['Entregues'].includes(params['status'])) {
          this.dataSelecionada = this.datas[3];
        }
        
        if (params['valor_filtro_data_inicial']) {
          this.date = new Date(params['valor_filtro_data_inicial']);
        }
  
        if (params['valor_filtro_data_final']) {
          this.dateEnd = new Date(params['valor_filtro_data_final']);
        }
      }
    });

    this.aplicarFiltro();
  }

  aplicarFiltro() {
    // Aqui, verificamos se todas as variáveis estão corretamente preenchidas
    const filtros = {
      dataSelecionada: this.dataSelecionada,
      statusSelecionado: this.statusSelecionado,
      localizacaoSelecionada: this.localizacaoSelecionada,
      valorFiltro: this.valorFiltro,
      filtroSelecionada: this.filtroSelecionada,
      date: this.date,
      dateEnd: this.dateEnd,
      offset: 1
    };
    
    // Emite o evento para o componente pai
    this.filtroAplicado.emit(filtros);
  }

  onTipoDataChange(event: any) {
    if (event.value.id === 0) {
      this.date = null;
      this.dateEnd = null;
    }
  }
}